import * as ACTION from '../../Redux.constants';
import {viewFourComplete} from './ViewFourComplete';
import {viewFourDrop} from './ViewFourDrop';
import {viewFourHint} from './ViewFourHint';
import {viewFourRemoveStep} from './ViewFourRemoveStep';
import {viewFourSetStep} from './ViewFourSetStep';

export function ViewFourReducer(state, action) {
  switch (action.type) {
    case ACTION.VIEW_FOUR_DROP:
      return viewFourDrop(state, action.payload);
    case ACTION.VIEW_FOUR_SET_STEP:
      return viewFourSetStep(state, action.payload);
    case ACTION.VIEW_FOUR_REMOVE_STEP:
      return viewFourRemoveStep(state, action.payload);
    case ACTION.VIEW_FOUR_HINT:
      return viewFourHint(state, action.payload);
    case ACTION.VIEW_FOUR_COMPLETE:
      return viewFourComplete(state, action.payload);
    default:
      return state;
  }
}
